export default __webpack_public_path__ + "static/media/headerimage.cc97bcff.jpg";